import { createApiSlice } from 'app/createApiSlice'
import moment from 'moment-timezone'

export const transactionSummaryApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'transactionSummary/hooks',
  endpoints(builder) {
    return {
      fetchTransactionSummary: builder.query({
        query({ startDate, endDate, counterpartId, itemId }) {
          const params = {
            startDate: moment(startDate).toISOString(),
            endDate: moment(endDate).toISOString(),
          }
          if (counterpartId) {
            params.counterpartId = counterpartId
          }
          if (itemId) {
            params.itemId = itemId
          }
          return {
            url: '/api/v1/bussines/transaction-summary',
            params,
          }
        },
      }),
      fetchTransactionSummaryYear: builder.query({
        query({ year, counterpartId, itemId }) {
          const params = { year }
          if (counterpartId) {
            params.counterpartId = counterpartId
          }
          if (itemId) {
            params.itemId = itemId
          }
          return {
            url: '/api/v1/bussines/transaction-summary-year',
            params,
          }
        },
      }),
      fetchSummaryProducts: builder.query({
        query({ startDate, endDate, page = 0, size = 10, sortby = 'name', sortdir = 'ASC', counterpartId, itemId }) {
          const params = {
            startDate: moment(startDate).toISOString(),
            endDate: moment(endDate).toISOString(),
            page,
            size,
            sortby,
            sortdir,
          }
          if (counterpartId) {
            params.counterpartId = counterpartId
          }
          if (itemId) {
            params.itemId = itemId
          }
          return {
            url: '/api/v1/bussines/transaction-summary/products',
            params,
          }
        },
      }),
      fetchSummaryCounterparts: builder.query({
        query({ startDate, endDate, page = 0, size = 100, sortby = 'name', sortdir = 'ASC', search, itemId } = {}) {
          const params = {
            page,
            size,
            sortby,
            sortdir,
          }
          if (startDate) {
            params.startDate = moment(startDate).toISOString()
          }
          if (endDate) {
            params.endDate = moment(endDate).toISOString()
          }
          if (search) {
            params.search = search
          }
          if (itemId) {
            params.itemId = itemId
          }
          return {
            url: '/api/v1/bussines/transaction-summary/counterparts',
            params,
          }
        },
      }),
    }
  },
})

export const {
  useFetchTransactionSummaryQuery,
  useLazyFetchTransactionSummaryQuery,
  useFetchTransactionSummaryYearQuery,
  useLazyFetchTransactionSummaryYearQuery,
  useFetchSummaryProductsQuery,
  useLazyFetchSummaryProductsQuery,
  useFetchSummaryCounterpartsQuery,
  useLazyFetchSummaryCounterpartsQuery,
} = transactionSummaryApiSlice
